import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

interface NextStepProps {
    disabled?: boolean
    translationKey?: string
    fullWidth?: boolean
}

export const NextStep = (props: NextStepProps) => {
    const {disabled, translationKey, fullWidth} = {
        translationKey: 'continue',
        fullWidth: false,
        ...props
    }
    const { t } = useTranslation()

    return <Box mt={4}>
        <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={disabled}
            fullWidth={fullWidth}
        >
            {t(translationKey)}
        </Button>
    </Box>
}
